export default {
  name: 'dn-top-items',

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  computed: {
    classes() {
      return {
        'pg-items': true,
        [`pg-items--${this.id}`]: true,
      }
    },
  },

  render(h) {
    return h('div', {
      class: this.classes,
    }, this.$slots.default);
  },
}


// WEBPACK FOOTER //
// ./src/js/top/components/TopItems.js